<template>
	<div>
		<div class="d-grid d-sm-flex justify-content-sm-between gap-2 mb-2">
			<form role="form" style="min-width: 50%;" @submit.prevent="page = 1; loadData();">
				<div class="input-group">
					<input type="text" v-model="search" class="form-control" :placeholder="$t('placeholder.search')" />
					<button type="submit" class="btn btn-outline-secondary" :disabled="loading" :content="$t('tooltip.btn.search')" v-tippy="{placement: 'top'}">
						<font-awesome-icon :icon="['fas', loading ? 'spinner' : 'magnifying-glass']" :spin="loading" />
					</button>
				</div>
			</form>
			<button type="button" class="btn btn-outline-primary" @click="onShowAddModal()">{{$t('btn.add-specialities')}}</button>
		</div>
		<div class="table-responsive">
			<table class="table table-hover align-middle">
				<thead>
					<tr>
						<th scope="col">{{$t('text.name')}}</th>
						<th scope="col" class="text-center" width="50">{{$t('text.lang')}}</th>
						<th scope="col" class="text-end" width="250">
							<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="loading" />
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="speciality in specialities" :key="speciality.id">
						<td>{{speciality.name}}</td>
						<td class="text-center">{{speciality.lang.toUpperCase()}}</td>
						<td>
							<div class="btn-toolbar justify-content-end gap-2">
								<router-link :to="{path: '/editor/specialities/' + speciality.id + '/qualifications'}" class="btn btn-outline-secondary">
									{{$t('btn.qualifications')}}
								</router-link>
								<div class="btn-group">
									<button type="button" class="btn btn-outline-primary" @click="onShowEditModal(speciality.id)" :content="$t('tooltip.btn.change')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'pencil']" />
									</button>
									<button type="button" class="btn btn-outline-danger" @click="onShowDeleteModal(speciality.id)" :content="$t('tooltip.btn.delete')" v-tippy="{placement: 'top'}">
										<font-awesome-icon :icon="['fas', 'trash-can']" />
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-center mt-2">
			<div class="mb-1">{{$t('text.total-specialities')}}: {{specialities_count}}</div>
			<nav aria-label="Page navigation">
				<ul class="pagination justify-content-center mb-0">
					<li class="page-item" :class="{'disabled': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(page - 1)" aria-label="Previous">
							<font-awesome-icon :icon="['fas', 'chevron-left']" />
						</a>
					</li>
					<li class="page-item" :class="{'active': page == 1}">
						<a class="page-link" href="javascript://" @click="gotoPage(1)">1</a>
					</li>
					<li class="page-item disabled" v-if="page - paginationAlpha > 2">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == i}" v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
						<a class="page-link" href="javascript://" @click="gotoPage(i)">{{i}}</a>
					</li>
					<li class="page-item disabled" v-if="page + paginationAlpha < getPagesCount() - 1">
						<span class="page-link">...</span>
					</li>
					<li class="page-item" :class="{'active': page == getPagesCount()}" v-if="getPagesCount() > 1">
						<a class="page-link" href="javascript://" @click="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
					</li>
					<li class="page-item" :class="{'disabled': page == getPagesCount() || getPagesCount() == 0}">
						<a class="page-link" href="javascript://" @click="gotoPage(page + 1)" aria-label="Next">
							<font-awesome-icon :icon="['fas', 'chevron-right']" />
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import SpecialitiesAddModal from '@/components/modals/specialities/SpecialitiesAddModal';
import SpecialityEditModal from '@/components/modals/specialities/SpecialityEditModal';
import SpecialityDeleteModal from '@/components/modals/specialities/SpecialityDeleteModal';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'База специальностей | KMIB EDU Editor'});
	},
	data: () => ({
		specialities: [],
		specialities_count: 0,
		
		search: '',
		page: 1,
		limit: 25,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		range: lib.range,
		
		onShowAddModal(){
			let that = this;
			this.$vfm.show({
				component: SpecialitiesAddModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					add(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {},
			});
		},
		onShowEditModal(id){
			let that = this;
			this.$vfm.show({
				component: SpecialityEditModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					edit(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					speciality: this.specialities.find((el) => el.id == id),
				},
			});
		},
		onShowDeleteModal(id){
			let that = this;
			this.$vfm.show({
				component: SpecialityDeleteModal,
				bind: {
					styles: {
						display: 'block',
					},
				},
				on: {
					delete(close){
						that.loadData();
						close();
					},
					cancel(close){
						close();
					},
				},
				params: {
					speciality: this.specialities.find((el) => el.id == id),
				},
			});
		},
		
		async loadData(){
			this.loading = true;
			this.error = '';
			this.$router.push({query: Object.assign({}, this.$route.query, {
				search: this.search,
				page: this.page,
			})});
			const params = {
				search: this.search,
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetSpecialities(params);
			if(ret.success){
				this.specialities = ret.list;
				this.specialities_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.specialities_count / this.limit);
		},
	},
	async mounted(){
		this.appModel.pageTitle = 'title.specialities';
		
		if(this.$route.query.search) this.search = this.$route.query.search;
		if(this.$route.query.page) this.page = parseInt(this.$route.query.page || 1);
		
		await this.loadData();
		
		window.scrollTo(0, 0);
	},
	beforeMount(){
		if(this.authModel.isAuth()){
			if(this.authModel.isAdmin()){
				this.$router.push({path: '/admin'});
			} else if(this.authModel.isStudent()){
				this.$router.push({path: '/'});
			}
		}
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
};
</script>